import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manager';

const list = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/noteTags`),
		{
			branchId,
		}
	);
};

const find = (systemSource, merchantId, branchId, id) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/noteTags/${id}`),
		{
			branchId,
		}
	);
};

const create = (systemSource, merchantId, branchId, name, operateBy) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/noteTags`),
		{
			branchId,
			name,
			operateBy,
			stopFlag: 0,
		}
	);
};

const update = (systemSource, merchantId, branchId, id, name, operateBy) => {
	return Client.put(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/noteTags/${id}`),
		{
			branchId,
			name,
			operateBy,
			stopFlag: 0,
		}
	);
};

const remove = (systemSource, merchantId, branchId, id, operateBy) => {
	return Client.del(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/noteTags/${id}`),
		{
			branchId,
			operateBy,
		}
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
